import { isFinite } from 'lodash-es';

type CurrencyFormatterArgs = Intl.NumberFormatOptions & {
  amount?: number;
  currency?: string;
};

const DEFAULT_CURRENCY = 'USD';

export const currencyFormatter = (args: CurrencyFormatterArgs = {}): string | false => {
  const { amount, currency = DEFAULT_CURRENCY, ...options } = args;

  if (!amount && amount !== 0) {
    return false;
  }

  return numberFormatter(amount, {
    style: 'currency',
    currency: currency || DEFAULT_CURRENCY,
    currencyDisplay: 'code',
    ...options,
  });
};

export const numberFormatter = (value: number | string, options: Intl.NumberFormatOptions = {}): string | false => {
  const parsedAmount = Number.parseFloat(value.toString());

  if (!isFinite(parsedAmount)) {
    return false;
  }

  const isInteger = Number.isInteger(Number(parsedAmount));

  return Number(parsedAmount).toLocaleString('en-US', {
    minimumFractionDigits: isInteger ? 0 : 2,
    maximumFractionDigits: 2,
    ...options,
  });
};
